import type { BackgroundColor } from "../constants/backgroundColors";
import { DEFAULT_BACKGROUND_COLOR } from "../constants/backgroundColors";
import type { BackgroundPatternType } from "../constants/backgroundPatterns";
import { DEFAULT_BACKGROUND_PATTERN } from "../constants/backgroundPatterns";
import type { CardStyleId } from "../constants/cardStyles";
import { DEFAULT_CARD_STYLE } from "../constants/cardStyles";
import { DEFAULT_SORT_OPTION } from "../constants/sortOptions";
import type { SortBy, SortOrder } from "./index";

export type { BackgroundPatternType as BackgroundPattern };
export type ViewLayout = "minimal" | "compact" | "full";

export interface ViewFieldSettings {
  logo: boolean;
  provider: boolean;
  description: boolean;
  releaseDate: boolean;
  devCountry: boolean;
  updatedAt: boolean;
  tags: boolean;
  actions: boolean;
}

export interface ViewSettings {
  layout: ViewLayout;
  fields: ViewFieldSettings;
  density?: string;
  showPrivateMemo: boolean;
  cardStyle: CardStyleId;
  colorPickerAlwaysVisible: boolean;
  backgroundColor: BackgroundColor;
  backgroundPatternType: BackgroundPatternType;
  sortBy: SortBy;
  sortOrder: SortOrder;
  /** @deprecated Use backgroundColor + backgroundPatternType instead */
  backgroundPattern?: string;
  forceUpdateAt?: number;
}

export const DEFAULT_VIEW_SETTINGS: ViewSettings = {
  layout: "compact",
  fields: {
    logo: true,
    provider: true,
    description: true,
    releaseDate: true,
    devCountry: true,
    updatedAt: false,
    tags: true,
    actions: true,
  },
  showPrivateMemo: true,
  cardStyle: DEFAULT_CARD_STYLE,
  colorPickerAlwaysVisible: true,
  backgroundColor: DEFAULT_BACKGROUND_COLOR,
  backgroundPatternType: DEFAULT_BACKGROUND_PATTERN,
  sortBy: DEFAULT_SORT_OPTION.sortBy,
  sortOrder: DEFAULT_SORT_OPTION.sortOrder,
};
